module.exports = __webpack_public_path__ + "static/img/mmmp.9a12450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/mmmp.png
// module id = Q++7
// module chunks = 0